import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Col, Row, ControlLabel } from "react-bootstrap";
import moment from "moment";
import Card from "../../../components/Card/Card";
import "jqwidgets-scripts/jqwidgets/styles/jqx.base.css";
import "jqwidgets-scripts/jqwidgets/styles/jqx.material-purple.css";
import "jqwidgets-scripts/jqwidgets/styles/jqx.material.css";
import Loading from "../../../views/Loading";
import '../Produccion/style.css';
// import axios from 'axios';
import { dominio } from "../../../routes_backend/routes.jsx";




class ControlTiemposMuertos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: "",
      DataPlanta: [
        { U_localidad: "CKC-K1", Code: "CKC-K1" },
        { U_localidad: "CKC-K2", Code: "CKC-K2" },
        { U_localidad: "CKC-K3", Code: "CKC-K3" },
        { U_localidad: "CKC-K4", Code: "CKC-K4" },
        { U_localidad: "CKC-K5", Code: "CKC-K5" },
        // { U_localidad: "CKC-K5", Code: "CKC-K6" },
        { U_localidad: "Tejas", Code: "Tejas" },
        { U_localidad: "Tejas 2", Code: "Tejas 2" },
        { U_localidad: "PVG", Code: "PVG" },
        { U_localidad: "PVE", Code: "PVE " },
        { U_localidad: "PVE2", Code: "PVE2" },
        { U_localidad: "PVC", Code: "PVC" },
        { U_localidad: "PVX", Code: "PVX" },
        { U_localidad: "PVR", Code: "PVR" },
        { U_localidad: "PVR2", Code: "PVR2" },
        { U_localidad: "PVH", Code: "PVH" },
        { U_localidad: "PAE", Code: "PAE" },
        { U_localidad: "PAX", Code: "PAX" },


      ],
      DataDepartamentos: [      
        { U_IdDepto: "PRODUCCION", U_Departamento: "PRODUCCION" },
        { U_IdDepto: "MANTTO_IND", U_Departamento: "MANTTO_IND " },
        { U_IdDepto: "MANTTO_LOGIS", U_Departamento: "MANTTO_LOGIS" },
        { U_IdDepto: "COMERCIAL", U_Departamento: "COMERCIAL" },
        { U_IdDepto: "COMPRAS", U_Departamento: "COMPRAS" },
        { U_IdDepto: "EXTERNOS", U_Departamento: "EXTERNOS" },
        { U_IdDepto: "CONTROL DE CALIDAD", U_Departamento: "CONTROL DE CALIDAD" },
      ],
      DataAreas: [
        { U_IdArea: "PRODUCCION1", U_Area: "PRODUCCION1" },
        { U_IdArea: "EXTERNOS1", U_Area: "EXTERNOS1 " },
        { U_IdArea: "FALLO_ELÉCTRICO", U_Area: "FALLO_ELÉCTRICO" },
        { U_IdArea: "FALLO_MECÁNICO", U_Area: "FALLO_MECÁNICO" },
        { U_IdArea: "FALLO_SOLDADURA", U_Area: "FALLO_SOLDADURA" },
        { U_IdArea: "MOLDE", U_Area: "MOLDE" },
        { U_IdArea: "MANTTO_LOGIS1", U_Area: "MANTTO_LOGIS1" },
        { U_IdArea: "COMERCIAL1", U_Area: "COMERCIAL1" },
        { U_IdArea: "COMPRAS1", U_Area: "COMPRAS1" },
        
      ],
      DataActivos: [],
      isLoading: false,
      is_planta: "Seleccione Planta",
      is_depto: "Seleccione Departamento",
      is_area: "Seleccione Area",
      is_elemento: "Seleccione Elemento",
      is_componente: "Seleccione Componente",
      tiempoLaboral: false,
      from_Date:"",
      message: "",      
      horaInicial: '',
      horaFinal: '',
      tiempoCalculado: '',
      planta: "",
      area: "",
      depto: "",
      elemento: "",
      componente: "",
      comentario: '',
      ingresoOTs: '',

  

      dataElemento: [
        { elemento: "ARIDOS" },
        { elemento: "MEZCLADORA" },
        { elemento: "PRENSA" },
        { elemento: "INYECTORES" },
        { elemento: "1" },
        { elemento: "2" },

      ],

      dataComponente: [
        { componente: "TORNILLERIA" },
        { componente: "FAJA" },
        { componente: "CABLEADO" },
        { componente: "FUENTE" },
        { componente: "1" },
        { componente: "2" },
      ],


    };
  }

  onChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      showReport: false,
    });
  };

  onChangePlanta = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      showReport: false,
    }, () => {



     
    var username = '';
    var password = '';
    let token = localStorage.getItem('token');
    let token_Data = JSON.parse(token);

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
      });
    }

    if (token_Data === null) {
      this.props.history.push(''); // Ajusta la redirección según tus necesidades
    }

    const response = fetch(`${dominio}/get_TMListaDepartamentos`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
      body: JSON.stringify({ 
        username,
        password,       
        
      }),
			});
		
			response
			.then(async (res) => {
				let dataDepartmentos = await res.json();
				console.log(dataDepartmentos);
				let temp_DataDepartamentos = [];
				dataDepartmentos.forEach((element) => {
					let obj = {
            
						U_IdDepto: element.U_IdDepto,
						U_Departamento: element.U_Departamento,					

					};
					temp_DataDepartamentos.push(obj);
				});
				this.setState({
					message: '',
					isLoading: false,
					DataDepartamentos: temp_DataDepartamentos,

				});
    
			})
			.catch((error) => {
				console.log(error);
				this.setState({
					isLoading: false,
					message: 'error in the server'
				});
			});
    });
    

    
  };




  onChangeDepartamento = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      showReport: false,
    }, () => {   

      
    const { is_planta, is_depto   } = this.state;
    console.log(is_planta); 
    console.log(is_depto); 

    var username = '';
    var password = '';
    let token = localStorage.getItem('token');
    let token_Data = JSON.parse(token);

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
      });
    }

    if (token_Data === null) {
      this.props.history.push('');
    }

    const response = fetch(`${dominio}/get_TMListaArea`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
      body: JSON.stringify({ 
        username,
        password,
        is_planta,
        is_depto,        
      }),
			});

		
			response
			.then(async (res) => {
				let dataAreas = await res.json();
				console.log(dataAreas);
				let temp_DataAreas = [];
				dataAreas.forEach((element) => {
					let obj = {
            
						U_IdArea: element.U_IdArea,
						U_Area: element.U_Area,					

					};
					temp_DataAreas.push(obj);
				});
				this.setState({
					message: '',
					isLoading: false,
					DataAreas: temp_DataAreas,

				});
    
			})
			.catch((error) => {
				console.log(error);
				this.setState({
					isLoading: false,
					message: 'error in the server'
				});
			});


    });
    

    
  };


  onChangeAreas = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      showReport: false,
    }, () => {   

      
    const { is_planta, is_depto, is_area   } = this.state;
  

    var username = '';
    var password = '';
    let token = localStorage.getItem('token');
    let token_Data = JSON.parse(token);

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
      });
    }

    if (token_Data === null) {
      this.props.history.push(''); // Ajusta la redirección según tus necesidades
    }

    const response = fetch(`${dominio}/get_TMListaActivos`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
      body: JSON.stringify({ 
        username,
        password,
        is_planta,
        is_depto,
        is_area        
      }),
			});

      console.log(is_planta);
      console.log(is_depto);
      console.log(is_area);
		
			response
			.then(async (res) => {
				let dataActivos = await res.json();
				console.log(dataActivos);
				let temp_DataActivos = [];
				dataActivos.forEach((element) => {
					let obj = {
            
						U_GrpActivo: element.U_GrpActivo,
						U_Activo: element.U_Activo,					

					};
					temp_DataActivos.push(obj);
				});
				this.setState({
					message: '',
					isLoading: false,
					DataActivos: temp_DataActivos,

				});
    
			})
			.catch((error) => {
				console.log(error);
				this.setState({
					isLoading: false,
					message: 'error in the server'
				});
			});
    });
    

    
  };
 


  onChangeFromDate(date) {
		this.setState({ from_Date: date });
	}

  handleDateChangeFrom = (e, date2) => {
    this.setState({ date2: e.target.value });
    const date_from_from = moment(e.target.value).format('YYYYMMDD');

    
    this.setState({
      from_fecha: date_from_from,
    });
  }

 

  onChangeComentario = (event) => {
    this.setState({ comentario: event.target.value });
  };

  onChangeIngresoOTs = (event) => {
    this.setState({ ingresoOTs: event.target.value });
  };

  onChangeTiempoLaboral = () => {
    const { tiempoLaboral } = this.state;
    // Toggle del estado tiempoLaboral
    this.setState({ tiempoLaboral: !tiempoLaboral });

    // Reiniciar valores cuando se desactiva el checkbox
    if (!tiempoLaboral) {
      this.setState({
        is_depto: '',
        is_area: '',
        is_elemento: '',
        is_componente: '',
      });
    }
  };

  componentDidMount() {
    
    this.setState({
      isLoading: true,
    });
    
    var username = '';
    var password = '';
    let token = localStorage.getItem('token');
    let token_Data = JSON.parse(token);

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
      });
    }

    if (token_Data === null) {
      this.props.history.push(''); // Ajusta la redirección según tus necesidades
    }

    const response = fetch(`${dominio}/get_TMListaPlantas`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
      body: JSON.stringify({ 
        username,
        password,       
        
      }),
			});
		
			response
			.then(async (res) => {
				let dataPlantas = await res.json();
				console.log(dataPlantas);
				let temp_DataPlantas = [];
				dataPlantas.forEach((element) => {
					let obj = {
            
						U_localidad: element.U_localidad,
						Code: element.Code,					

					};
					temp_DataPlantas.push(obj);
				});
				this.setState({
					message: '',
					isLoading: false,
					DataPlanta: temp_DataPlantas,

				});
    
			})
			.catch((error) => {
				console.log(error);
				this.setState({
					isLoading: false,
					message: 'error in the server'
				});
			});


  }

  

  // Función para manejar la acción de cierre de sesión
  handleLogout = () => {
    // Realiza aquí las acciones de cierre de sesión, como eliminar el token y redirigir al usuario a la página de inicio de sesión.
    localStorage.removeItem('TOKEN');
    localStorage.removeItem('token');
    this.props.history.push("/");
  };

  // Funciones que manejan las interacciones del usuario (por ejemplo, clics, pulsaciones de teclas, etc.)



  handleGuardar = () => {


   
    const {
      from_fecha,
      is_planta,
      is_depto,
      is_area,
      is_elemento,
      is_componente,
      horaInicial,
      horaFinal,
      comentario,
      tiempoCalculado
    } = this.state;

  console.log(is_planta);
  console.log(is_depto);
   
    if (from_fecha === undefined) {
      alert('Debe seleccionar una fecha.');
      return;
    }

    if (is_planta === 'Seleccione Planta') {
      alert('Debe seleccionar una planta.');
      return;
    }
    if (is_depto === 'Seleccione Departamento') {
      alert('Debe seleccionar un departamento.');
      return;
    }

    if (is_area === 'Seleccione Area') {
      alert('Debe seleccionar un área.');
      return;
    }

    if (is_elemento === 'Seleccione Elemento') {
      alert('Debe seleccionar un elemento.');
      return;
    }

    if (is_componente === 'Seleccione Componente') {
      alert('Debe seleccionar un componente.');
      return;
    }

    if (horaInicial === '') {
      alert('Debe ingresar una hora inicial.');
      return;
    }

    if (horaFinal === '') {
      alert('Debe ingresar una hora final.');
      return;
    }
    if (comentario === '') {
      alert('Debe escribir un comentario');
      return;
    } 

    // Formatear las horas sin dos puntos
    const horaInicio = horaInicial.split(':');
    const horaFin = horaFinal.split(':');

    let horaInicioFormateada = horaInicio.join('');
    let horaFinFormateada = horaFin.join('');

     var username = "";
     var password = "";
     var User_Code = "";
     var User_Id = "";
     let token = localStorage.getItem("token"); 
     let token_Data = JSON.parse(token); 
     if (token_Data !== null) {
       token_Data.forEach((element) => {
         username = element.usuarioSAP;
         password = element.contraseñaSAP;
         User_Code = element.user_code;
         User_Id = element.user_id;
       });
     }

     
     if (token_Data === null) {
       this.props.history.push("");
     }



    const response = fetch(`${dominio}/registrar`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        username,
        password,
        from_fecha,
        is_planta,
        is_depto,
        is_area,
        is_elemento,
        is_componente,
        horaInicial: horaInicioFormateada,
        horaFinal: horaFinFormateada,
        tiempoCalculado,
        comentario,
        User_Code,
        User_Id
      }),
    });
  
    response
      .then((res) => res.json(), )
      .then((data) => {


        if (data[0].success) {
          // const tableDetails = JSON.parse(data[0]);
          alert('TM Creado existosamente.');
          return;
          // console.log('TM Creado Exitosamente');          
   
        } else {
          console.error('Error en la solicitud:', data[0].message);
        }
     
      })
      .catch((error) => {
        console.error('Error en la solicitud:', error);
      });


    
  };

  onChangeHoraInicial = (event) => {
    this.setState({ horaInicial: event.target.value }, this.calcularTiempo);
   
  };

  onChangeHoraFinal = (event) => {
    this.setState({ horaFinal: event.target.value }, this.calcularTiempo);
  };

  calcularTiempo = () => {
    const { horaInicial, horaFinal } = this.state;
    
    if (horaInicial && horaFinal) {
      const horaInicio = horaInicial.split(':');
      const horaFin = horaFinal.split(':');

      const fechaInicio = new Date(0, 0, 0, horaInicio[0], horaInicio[1]);
      const fechaFin = new Date(0, 0, 0, horaFin[0], horaFin[1]);

      const diferencia = fechaFin - fechaInicio;

      const horas = Math.floor(diferencia / 1000 / 60 / 60);
      const minutos = Math.floor((diferencia / 1000 / 60) % 60);

      // Asegurar que las horas y minutos tengan dos dígitos
      const horasFormateadas = horas.toString().padStart(2, '0');
      const minutosFormateados = minutos.toString().padStart(2, '0');

      const tiempoCalculado = `${horasFormateadas}${minutosFormateados}`;

      this.setState({ tiempoCalculado });
    } else {
      this.setState({ tiempoCalculado: '' });
    }
};

  render() {
    const {
      is_planta,
      is_depto,
      is_area,
      is_elemento,
      is_componente,
      dataComponente,
      isLoading,
      DataPlanta,
      DataDepartamentos,
      DataAreas,
      DataActivos
    } = this.state;
    return (
      <div
        className="content"
        style={{ textAlign: "center", alignItems: "center" }}
      >
        <Grid fluid>
          <Row>

            <Card
              title="Control de tiempos muertos"
              category=""
              ctTableFullWidth
              ctTableResponsive
              content={
                <div className="row"

                >


                  <div>
                    Registrar
                  </div>
                  <br />
                  <Col md={3}>

                    {/* Fecha */}
                    <div className="col-sm-12">
                      <div className="col-sm-12" style={{ textAlign: "center", alignItems: "center", transform: "scale(0.8)" }}>
                        <ControlLabel>Ingrese Fecha: </ControlLabel>
                        <br />
                        <input 
                        type="date" 
                        style={inputStyle} 
                        value={this.state.date} 
                        onChange={this.handleDateChangeFrom} />
                      </div>
                    </div>

                    {/* planta */}
                    <div className="col-sm-12">
                      <div className="col-sm-12" style={{ textAlign: "center", alignItems: "center", transform: "scale(0.8)" }}>
                      <br />
                     
                     
                        <label htmlFor="is_planta">
                          Seleccione Planta:
                        </label>
                        <select
                          value={is_planta}
                          name="is_planta"
                          id="is_planta"
                          className="form-control"
                          onChange={this.onChangePlanta}
                          onClick={() =>
                            this.setState({ is_planta: is_planta })
                          }
                        >
                          <option key={0} value="Seleccione Planta">
                            Seleccione Planta
                          </option>
                          {DataPlanta &&
                            DataPlanta.map((res) => (
                              <option key={res.U_localidad} value={res.U_localidad}>
                                {res.Code}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>


                    {/* teimpo laboral */}
                    <div className="col-sm-12">
                    <div className="col-sm-12" style={{ textAlign: "center", alignItems: "center", }}>
                        <br />
                        <label>
                          Tiempo Laboral
                          <input
                            type="checkbox"
                            checked={this.state.tiempoLaboral}
                            onChange={this.onChangeTiempoLaboral}

                          />

                        </label>
                      </div>
                    </div>

                    {/* Departamento */}
                    <div className="col-sm-12">
                      <div className="col-sm-12" style={{ textAlign: "center", alignItems: "center", transform: "scale(0.8)" }}>
                        <label htmlFor="is_depto">
                          Seleccione Departamento:
                        </label>
                        <select
                          value={is_depto}
                          name="is_depto"
                          id="is_depto"
                          className="form-control"
                          onChange={this.onChangeDepartamento}
                          onClick={() =>
                            this.setState({ is_depto: is_depto })
                          }
                          disabled={this.state.tiempoLaboral}

                        >
                          <option key={0} value="Seleccione Departamento">
                            Seleccione Departamento
                          </option>
                          {DataDepartamentos &&
                            DataDepartamentos.map((res) => (
                              <option key={res.U_IdDepto} value={res.U_IdDepto}>
                                {res.U_Departamento}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    
                    {/* Area */}
                    <div className="col-sm-12">
                      <div className="col-sm-12" style={{ textAlign: "center", alignItems: "center", transform: "scale(0.8)" }}>
                        <label htmlFor="is_area">
                          Seleccione Area:
                        </label>
                        <select
                          value={is_area}
                          name="is_area"
                          id="is_area"
                          className="form-control"
                          onChange={this.onChangeAreas}
                          onClick={() =>
                            this.setState({ is_area: is_area })
                          }
                          disabled={this.state.tiempoLaboral}
                        >
                          <option key={0} value="Seleccione Area">
                            Seleccione Area
                          </option>
                          {DataAreas &&
                            DataAreas.map((res) => (
                              <option key={res.U_IdArea} value={res.U_IdArea}>
                                {res.U_Area}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    {/* Elemento */}

                    <div className="col-sm-12">
                      <div className="col-sm-12" style={{ textAlign: "center", alignItems: "center", transform: "scale(0.8)" }}>
                        <label htmlFor="is_elemento">
                          Seleccione Elemento:
                        </label>
                        <select
                          value={is_elemento}
                          name="is_elemento"
                          id="is_elemento"
                          className="form-control"
                          onChange={this.onChange}
                          onClick={() =>
                            this.setState({ is_elemento: is_elemento })
                          }
                          disabled={this.state.tiempoLaboral}
                        >
                          <option key={0} value="Seleccione Elemento">
                            Seleccione Elemento
                          </option>
                          {DataActivos &&
                            DataActivos.map((res) => (
                              <option key={res.U_GrpActivo} value={res.U_GrpActivo}>
                                {res.U_Activo}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    {/* Componente */}

                    <div className="col-sm-12">
                      <div className="col-sm-12" style={{ textAlign: "center", alignItems: "center", transform: "scale(0.8)" }}>
                        <label htmlFor="is_componente">
                          Seleccione Componente:
                        </label>
                        <select
                          value={is_componente}
                          name="is_componente"
                          id="is_componente"
                          className="form-control"
                          onChange={this.onChange}
                          onClick={() =>
                            this.setState({ is_componente: is_componente })
                          }
                          disabled={this.state.tiempoLaboral}
                        >
                          <option key={0} value="Seleccione Elemento">
                            Seleccione Elemento
                          </option>
                          {dataComponente &&
                            dataComponente.map((res) => (
                              <option key={res.componente} value={res.componente}>
                                {res.componente}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                 {/* boton guardar */}
                    
                    <div className="col-sm-12">
                      <div className="col-sm-12" style={{ marginTop: "20px", textAlign: "center", alignItems: "center", }}>
                        <button
                          className="btn btn-primary"
                          onClick={this.handleGuardar}
                        >
                          Guardar
                        </button>
                      </div>
                    </div>
                  </Col>

                  <Col md={3}>

                    {/* Hora Inicial */}

                  <div className="col-sm-12">
                      <div className="col-sm-12" style={{ textAlign: "center", alignItems: "center", transform: "scale(0.8)" }}>
                        <br />
                        <ControlLabel>Hora Inicial: </ControlLabel>
                        <input
                          type="time"
                          value={this.state.horaInicial}
                          onChange={this.onChangeHoraInicial}
                        />
                      </div>
                    </div>

                    {/* Hora Final */}

                    <div className="col-sm-12">
                      <div className="col-sm-12" style={{ textAlign: "center", alignItems: "center", transform: "scale(0.8)" }}>
                        <ControlLabel>Hora Final: </ControlLabel>
                        <input
                          type="time"
                          value={this.state.horaFinal}
                          onChange={this.onChangeHoraFinal}
                        />
                      </div>
                    </div>

                    {/* Tiempo Calculado */}

                    <div className="col-sm-12">
                      <div className="col-sm-12" style={{ textAlign: "center", alignItems: "center", transform: "scale(0.8)" }}>
                        <ControlLabel>Tiempo Calculado: </ControlLabel>
                        <input
                          type="text"
                          value={this.state.tiempoCalculado}
                          readOnly
                        />
                      </div>
                    </div>

                    {/* Comentario */}
                  <div className="col-sm-12">
                      <div className="col-sm-12">
                        <br />
                        <ControlLabel>Comentario: </ControlLabel>
                        <br />
                        <textarea
                          rows="4"
                          cols="25"

                          value={this.state.comentario}
                          onChange={this.onChangeComentario}
                        />
                      </div>
                    </div>

                    {/* Ingrese OTs */}

                  <div className="col-sm-12">
                      <div className="col-sm-12" style={{ textAlign: "left", alignItems: "center", transform: "scale(0.8)" }}>
                        <ControlLabel>Ingrese OTs: </ControlLabel>
                        <br />
                        <input
                          type="text"
                          value={this.state.ingresoOTs}
                          onChange={this.onChangeIngresoOTs}
                        />
                      </div>
                    </div>
                    
             

                   
                  </Col>


                  <br />
                  <br />

                </div>
              }
            />

          </Row>
        </Grid>
        {isLoading && <Loading />}
      </div>
    );
  }
}

ControlTiemposMuertos.protoTypes = {

};

function mapStateToProps(state) {
  return {

  };
}

export default connect(mapStateToProps, {

})(ControlTiemposMuertos);

const inputStyle = {
  width: "200px",
  height: "40px",
  padding: "10px",
  fontSize: "16px",
  borderRadius: "5px"
};
